import { GoogleFormsIcon } from '../../../assets/icons/google-forms';
import { createEmbedProvider } from '../factory';

/**
 * Google Forms URL regex pattern
 * Matches: docs.google.com/forms/d/FORM_ID/... or docs.google.com/forms/d/e/LONG_FORM_ID/...
 * Captures the form ID path (including optional e/ prefix) in group 1.
 */
export const GOOGLE_FORMS_REGEX = /^https?:\/\/docs\.google\.com\/forms\/d\/((?:e\/)?[^/?#]+)/i;

export const googleFormsProvider = createEmbedProvider({
  id: 'google-forms',
  label: 'Google Forms',
  icon: <GoogleFormsIcon className="size-5" />,
  regex: GOOGLE_FORMS_REGEX,
  buildEmbedUrl: (match) => `https://docs.google.com/forms/d/${match[1]}/viewform?embedded=true`,
});
